var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinterClothing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 207.67 131.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: #f4f1e0;\n      }\n\n      .cls-4 {\n        fill: #ff0700;\n      }\n\n      .cls-5 {\n        fill: #a70000;\n      }\n\n      .cls-6 {\n        fill: #d70000;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-19 {\n        isolation: isolate;\n      }\n\n      .cls-20 {\n        opacity: .3;\n      }\n\n      .cls-20, .cls-21 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-21 {\n        opacity: .5;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 207.67,
    height: 131.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 207.67,
    height: 131.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m121.96,45.29l72.57,27.89c2.05.79,4.36-.17,5.25-2.19l3.3-7.5c.81-1.83.18-3.99-1.49-5.09L135.5,14.54l-13.54,30.75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 207.67,
    height: 131.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.9,58.4c-1.67,1.11-2.3,3.26-1.49,5.09l3.3,7.5c.89,2.01,3.2,2.98,5.25,2.19l72.57-27.89-13.53-30.75L5.9,58.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 207.67,
    height: 131.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.58,12.53c-5.85.46-10.58,5.62-11.52,12.17-1.76,12.09-3.28,24.15-4.32,36.11-.85,9.77-1.02,19.53-.36,29.34.66,9.75,1.77,19.55,3.51,29.4.31,1.73,1.72,3.07,3.42,3.26,22.29,2.37,44.58,2.37,66.87,0,1.71-.18,3.12-1.53,3.42-3.26,1.75-9.85,2.85-19.65,3.51-29.4.66-9.81.48-19.57-.36-29.34-1.04-11.95-2.56-24.02-4.32-36.11-.94-6.55-5.68-11.71-11.52-12.17-8.06-.62-16.11-.93-24.17-.93s-16.11.31-24.17.93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 207.67,
    height: 131.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.24,4.71c0,.64.78,1.22,2.1,1.69,1.92.68,4.97,1.13,8.41,1.13s6.49-.44,8.41-1.13c1.32-.47,2.1-1.06,2.1-1.69,0-1.56-4.7-2.82-10.51-2.82s-10.51,1.26-10.51,2.82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.24,
    y: 1.89,
    width: 21.02,
    height: 5.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.24,
    y: 1.89,
    width: 21.02,
    height: 3.32
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 207.67,
    height: 131.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.05,
    y: 47.58,
    width: 199.38,
    height: 76.99
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m197.65,72.65l4.43,1.96c.71.31,1.54,0,1.85-.72l3.62-8.2c.31-.71,0-1.54-.72-1.85l-4.42-1.96-4.76,10.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m199.79,71l3.3-7.5c.81-1.84.18-3.99-1.49-5.1L135.5,14.55l-13.53,30.75,72.57,27.89c2.05.79,4.37-.17,5.25-2.19"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.02,72.41l-4.43,1.96c-.71.31-1.54,0-1.85-.72L.12,65.46c-.31-.71,0-1.54.72-1.85l4.42-1.96,4.76,10.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m7.71,71l-3.3-7.5c-.81-1.84-.18-3.99,1.49-5.1L71.99,14.55l13.53,30.75L12.96,73.19c-2.05.79-4.37-.17-5.25-2.19"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m137.69,18.31c0,5.75-15.2,10.4-33.95,10.4s-33.95-4.66-33.95-10.4,15.2-10.4,33.95-10.4,33.95,4.66,33.95,10.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m137.34,129.24c-22.3,2.95-44.89,2.95-67.19,0-1.4-.2-2.54-1.51-2.54-2.9v-7.94c23.97-3.41,48.3-3.41,72.27,0v7.94c0,1.39-1.14,2.7-2.54,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m139.44,24.7c-.94-6.55-5.68-11.71-11.52-12.17-16.11-1.24-32.22-1.24-48.34,0-5.85.46-10.58,5.62-11.52,12.17-1.76,12.08-3.28,24.16-4.32,36.11-.84,9.77-1.02,19.53-.36,29.34.66,9.75,1.77,19.55,3.51,29.4.31,1.73,1.71,3.07,3.42,3.26,22.29,2.37,44.58,2.37,66.87,0,1.71-.18,3.12-1.53,3.42-3.26,1.74-9.85,2.85-19.65,3.51-29.4.66-9.81.49-19.56-.36-29.34-1.04-11.95-2.56-24.02-4.32-36.11"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "92.83 49.65 81.93 68.53 92.83 87.42 103.74 68.53 92.83 49.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "71.17 49.65 60.27 68.53 71.17 87.42 82.07 68.53 71.17 49.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "49.29 49.65 38.39 68.53 49.29 87.42 60.2 68.53 49.29 49.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "114.64 49.65 103.74 68.53 114.64 87.42 125.55 68.53 114.64 49.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "136.45 49.65 125.55 68.53 136.45 87.42 147.35 68.53 136.45 49.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "158.26 49.65 147.35 68.53 158.26 87.42 169.16 68.53 158.26 49.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m103.74,89.14l-11.9-20.61,11.9-20.61,11.9,20.61-11.9,20.61Zm-9.91-20.61l9.91,17.17,9.91-17.17-9.91-17.17-9.91,17.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m125.55,89.14l-11.9-20.61,11.9-20.61,11.9,20.61-11.9,20.61Zm-9.91-20.61l9.91,17.17,9.91-17.17-9.91-17.17-9.91,17.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m147.35,89.14l-11.9-20.61,11.9-20.61,11.9,20.61-11.9,20.61Zm-9.91-20.61l9.91,17.17,9.91-17.17-9.91-17.17-9.91,17.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.93,89.14l-11.9-20.61,11.9-20.61,11.9,20.61-11.9,20.61Zm-9.91-20.61l9.91,17.17,9.91-17.17-9.91-17.17-9.91,17.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m60.12,89.14l-11.9-20.61,11.9-20.61,11.9,20.61-11.9,20.61Zm-9.91-20.61l9.91,17.17,9.91-17.17-9.91-17.17-9.91,17.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m88.66,10.8c0-.34.09-.67.27-.99l-.27.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m118.84,10.8l-.27-.99c.18.32.27.65.27.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m118.57,9.81l-1.37-5.1C117.2,2.11,111.18,0,103.75,0s-13.46,2.11-13.46,4.71l-1.37,5.1-.27.99c0,2.92,6.76,5.29,15.09,5.29s15.09-2.37,15.09-5.29l-.27-.99Zm-14.82-7.92c5.81,0,10.51,1.26,10.51,2.82,0,.64-.78,1.22-2.1,1.69-1.92.68-4.97,1.13-8.41,1.13s-6.49-.44-8.41-1.13c-1.32-.47-2.1-1.06-2.1-1.69,0-1.56,4.7-2.82,10.51-2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m114.26,4.71c0,.64-.78,1.22-2.1,1.69-1.92.68-4.97,1.13-8.41,1.13s-6.49-.44-8.41-1.13c-1.32-.47-2.1-1.06-2.1-1.69,0-1.56,4.7-2.83,10.51-2.83s10.51,1.26,10.51,2.83"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m114.26,4.71c0,.64-.78,1.22-2.1,1.69-1.92.68-4.97,1.13-8.41,1.13s-6.49-.44-8.41-1.13c-1.32-.47-2.1-1.06-2.1-1.69,0-1.56,4.7-2.83,10.51-2.83s10.51,1.26,10.51,2.83"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m114.26,4.71c0,.64-.78,1.22-2.1,1.69-1.92.68-4.97,1.13-8.41,1.13s-6.49-.44-8.41-1.13c-1.32-.47-2.1-1.06-2.1-1.69,0-1.56,4.7-2.83,10.51-2.83s10.51,1.26,10.51,2.83"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m103.75,2.87c5.18,0,9.48,1.01,10.35,2.33.1-.16.16-.32.16-.49,0-1.56-4.7-2.82-10.51-2.82s-10.51,1.26-10.51,2.82c0,.17.06.33.16.49.86-1.33,5.17-2.33,10.35-2.33"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m199.79,64.93c-.89,2.01-3.2,2.98-5.25,2.19l-50.08-19.25c-2.86-1.1-5.88,1.17-5.63,4.23.13,1.61.26,3.22.38,4.83.75,10.21.9,20.4.32,30.64-.58,10.19-1.57,20.42-3.12,30.71-.27,1.81-1.52,3.21-3.03,3.4-19.76,2.47-39.51,2.47-59.27,0-1.51-.19-2.76-1.6-3.03-3.4-1.55-10.28-2.53-20.52-3.12-30.71-.58-10.24-.43-20.44.32-30.64.12-1.61.25-3.22.38-4.83.25-3.05-2.76-5.33-5.62-4.23l-50.08,19.25c-2.05.79-4.36-.17-5.25-2.19l-2.58-5.86c-1.07,1.18-1.39,2.91-.72,4.43l3.3,7.5c.89,2.01,3.2,2.98,5.25,2.19l51.49-19.79c-.25,2.47-.49,4.94-.71,7.41-.85,9.77-1.02,19.53-.36,29.34.66,9.75,1.77,19.55,3.51,29.4.31,1.73,1.72,3.08,3.42,3.26,22.29,2.37,44.58,2.37,66.87,0,1.71-.18,3.12-1.53,3.42-3.26,1.74-9.85,2.85-19.65,3.51-29.4.66-9.81.49-19.57-.36-29.34-.21-2.46-.45-4.93-.71-7.41l51.49,19.79c2.05.79,4.37-.17,5.25-2.19l3.3-7.5c.67-1.52.35-3.25-.72-4.43l-2.58,5.86Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterClothing);
export default __webpack_public_path__ + "static/media/winter-clothing.c7fef4264bc4befd5902a2baaf63ed96.svg";
export { ForwardRef as ReactComponent };